import DateBox from 'devextreme-react/date-box'
import {usePeriod} from '../../contexts/period'
import {calendarOptions, useInitPeriod} from './select-period-shared'

const SelectPeriodEnd = ({
    style,
    initPeriod = false,
    label = 'Период окончания:',
    displayFormat = 'MM.yyyy'
}) => {
    const { periodEnd, setPeriodEnd } = usePeriod()
    useInitPeriod(initPeriod)

    return (
        <div style={{...style }}>
            <DateBox
                labelMode={'floating'}
                label={label}
                calendarOptions={calendarOptions}
                value={periodEnd}
                onValueChange={setPeriodEnd}
                openOnFieldClick={true}
                displayFormat={displayFormat}
                useMaskBehavior={true}
            />
        </div>
    )
}

export default SelectPeriodEnd
